import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row py-5 py-md-4 pb-md-0 align-items-baseline" }
const _hoisted_2 = { class: "col-12 col-lg-6 ps-3 list-unstyled" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex flex-row align-items-center"
}
const _hoisted_4 = { class: "body text-grey-900 ps-3" }
const _hoisted_5 = {
  key: 1,
  class: "py-md-5 py-2 d-flex flex-row"
}
const _hoisted_6 = { class: "body text-grey-900 ps-3" }
const _hoisted_7 = {
  key: 2,
  class: "d-flex flex-row align-items-center"
}
const _hoisted_8 = { class: "body text-grey-900 ps-3" }

import MountainInfoLogo from "./MountainInfoLogo.vue";

interface DomainStatsProps {
  pisteLength: string | number;
  nbSlopes: number;
  nbSkiLifts: number;
  data: Record<string, any>;
  stationData: Record<string, any>;
  content: Record<string, string>;
  isConnectedDomain: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SkiAreaStats',
  props: {
    pisteLength: {},
    nbSlopes: {},
    nbSkiLifts: {},
    data: {},
    stationData: {},
    content: {},
    isConnectedDomain: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_ctx.pisteLength)
        ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
            _cache[0] || (_cache[0] = _createElementVNode("span", null, [
              _createElementVNode("svg", { class: "icon" }, [
                _createElementVNode("use", { href: "#___icon___snowed-mountains" })
              ])
            ], -1)),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.pisteLength) + " " + _toDisplayString(_ctx.content.station_kmSlopes), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.nbSlopes)
        ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("span", null, [
              _createElementVNode("svg", { class: "icon" }, [
                _createElementVNode("use", { href: "#___icon___skiing-person-blue" })
              ])
            ], -1)),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.nbSlopes) + " " + _toDisplayString(_ctx.content.station_NumberSlopes), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.nbSkiLifts)
        ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
            _cache[2] || (_cache[2] = _createElementVNode("span", null, [
              _createElementVNode("svg", { class: "icon" }, [
                _createElementVNode("use", { href: "#___icon___ski-lift" })
              ])
            ], -1)),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.nbSkiLifts) + " " + _toDisplayString(_ctx.content.station_NumberLifts), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(MountainInfoLogo, {
      data: _ctx.data,
      stationData: _ctx.stationData,
      content: _ctx.content,
      isConnectedDomain: _ctx.isConnectedDomain
    }, null, 8, ["data", "stationData", "content", "isConnectedDomain"])
  ]))
}
}

})